import { render, staticRenderFns } from "./CalculationInputs.vue?vue&type=template&id=a2b889ae&"
import script from "./CalculationInputs.vue?vue&type=script&lang=js&"
export * from "./CalculationInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports